import React from 'react';
import { ThematicSubsectionsInput, type ThematicSubsection } from './ThematicSubsectionsInput';

interface ThematicSubsectionsFieldProps {
  label: string;
  required?: boolean;
  value: ThematicSubsection[];
  onChange: (_sections: ThematicSubsection[]) => void;
  error?: string;
}

export const ThematicSubsectionsField: React.FC<ThematicSubsectionsFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <ThematicSubsectionsInput value={value ?? []} onChange={onChange} />
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};
